var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "activemanagedworkflow",
	init: init,
	listeners: listeners,
	triggers: triggers,

	_who: null,
	_workflow: null,
	_history: {},
	_definitions: [],
	_ongoing: [],
	_actions: [],
	_people: {},
	_patientGroups: {},
	_isHistory: false,

	recalculate: recalculate,
});

function init(){
	this.push(null);
}

function triggers() {
	return {
		view: view,
		reset: reset,
	};
}

function listeners(){
	return {
		"managedactionsworkflow:updated": Model.makeRecalculator("actions"),
		"manageddefinitionworkflow:updated": Model.makeRecalculator("definitions"),
		"managedongoingworkflow:updated": Model.makeRecalculator("ongoing"),
		"managedhistoryworkflow:updated": Model.makeRecalculator("history"),
		"people:updated": Model.makeRecalculator("people"),
		"managedpatientgroups:updated": handlePatientGroupsUpdated
	};
}

function recalculate(){
	var workflow = this._workflow;
	if(!workflow) return;

	var source = this._isHistory ? this._history.history || [] : this._ongoing;
	var workflowData = findById(workflow, source);
	if(!workflowData) return;
	var workflowDefinition = findById(workflowData.workflow, this._definitions);
	if(!workflowDefinition) return;
	var actions = this._actions;
	var people = this._people;
	const patientGroups = this._patientGroups;

	var actors = workflowData.actors.map(function(actorData){
		var person = people[actorData.who] || patientGroups[actorData.who] || { _id: actorData.who };
		return xtend(actorData, {
			who: person
		});
	});

	this.push(xtend(workflowData, {
		actors: actors,
		definition: workflowDefinition.schema,
		actions: actions
	}));
}

function view(data){
	var workflow = data.workflow;
	var who = data.who;
	var group = data.group;
	var isHistory = data.history;

	this._isHistory = isHistory;
	this._who = who;
	this._workflow = workflow;

	this.recalculate();

	this.emit("managedactionsworkflow:trigger:view", {
		workflow: workflow,
		group: group,
		who: who
	});

	this.dispatch("viewing");

	this.emit("usermetrics:trigger:track", "view pathway", {
		pathway: workflow,
	});
}

function reset(){
	this._isHistory = false;
	this._who = null;
	this._workflow = null;
	this.push(null);

	this.emit("managedactionsworkflow:trigger:reset");
	this.emit("usermetrics:trigger:track", "refresh managed active pathways");
}

function findById(id, list){
	return list.reduce(function(result, item){
		if(item._id === id) return item;
		return result;
	}, null);
}

function handlePatientGroupsUpdated(groups){
	this._patientGroups = groups.reduce((result, group) => {
		result[group._id] = group;
		return result;
	}, {});
	this.recalculate();
}
